import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';

export const LinkSection = ({
  link = "",
  linkText = "View detail",
  disableLink = false,
  disableLinkText = "Deleted",
  openNewTab,
}) => {
  if (!link) {
    return null;
  };
  if (disableLink) {
    return <label className='profile-section-link-disabled'>{disableLinkText}</label>
  };
  return <Link
    className="profile-section-link"
    to={link}
    target={openNewTab ? "_blank" : ""}
    rel={openNewTab ? "noopener noreferrer" : ""}
  >{linkText}</Link>
};

export const LinkButtonSection = ({
  link = "",
  linkText = "View detail",
  disableLink = false,
  disableLinkText = "Deleted",
}) => {
  if (!link) {
    return null;
  };
  if (disableLink) {
    return <label className='profile-section-link-disabled'>{disableLinkText}</label>
  };
  return <Button
    className={'btn-back-button-common btn-download btn btn-primary'}
    onClick={() => {
      window.open(link, "_blank")
    }}
  >
    {linkText}
  </Button>
};
